import { Component, Inject } from '@angular/core';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { LastStepActionConfig } from '../../../../../../core/action-configs/kyc/last-step.action-config';
import { LastStepRepeatActionConfig } from '../../../../../../core/action-configs/kyc/last-step-repeat.action-config';
import { ActionFormModal } from '../../../../../../core/modals/action-form/action-form.modal';
import { ActionConfigAbstract } from '../../../../../../core/services/actions/abstracts/action-config.abstract';
import { IDataService } from '../../../../../../core/services/data/data-service.interface';
import { RbacServiceInterface } from '../../../../../../core/services/rbac/rbac-service.interface';
import { LastStepResponse } from './last-step.response';
import { LastStepConfirmActionConfig } from '../../../../../../core/action-configs/kyc/last-step-confirm.action-config';

@Component({
  selector: 'gtd-last-step',
  templateUrl: './last-step.component.html',
})
export class LastStepComponent extends GtdNgWidgetComponentAbstract {
  protected key = 'AffiliateCrm\\KYC\\LastStep';
  public data = new LastStepResponse();

  constructor(
    @Inject(IMODALS_SERVICE) private modalsService: IModalsService,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('RbacServiceInterface') private rbacService: RbacServiceInterface
  ) {
    super();
  }

  public afterData(): void {
    const item = this.data.data;
    // "0": "Pending From Affiliate"
    // "1": "Pending From TS"
    // "2": "Done"
    // "3": "Blocked By Affiliate"
    // "4": "Blocked"
    if (item) {
      let config: ActionConfigAbstract;
      let id = null;
      switch (item.state) {
        case 0: {
          let url = '';
          try {
            url = JSON.parse(item.process).data;
          } catch {}
          config = new LastStepConfirmActionConfig(this.dataService, this.rbacService, url);
          config.setTitle(`${$localize`:@@common.confirm_step:Confirm a step`} "${item.name}"`);
          id = item.affiliate_step_id;
          break;
        }
        case 4:
          config = new LastStepRepeatActionConfig(this.dataService, this.rbacService, 'Declined reason:\n' + (item.declined_reason || ''));
          config.setTitle(`${$localize`:@@common.repeat_step:Repeat a step`} "${item.name}"`);
          id = item.affiliate_step_id;
          break;
        default:
          config = new LastStepActionConfig(this.dataService, this.rbacService);
          config.setTitle(`${$localize`:@@common.pass_step:Pass a step`} "${item.name}"`);
          break;
      }
      config.setDescription(item.description);
      this.modalsService.open(ActionFormModal, {
        data: {
          config: () => config,
          id,
          repository: {
            step_id: item.id,
          },
        },
      });
    }
  }
}
